import {
  mailingServices,
  PriceCalculatorComponent,
  PriceInfoComponent,
  QuantitySelectorComponent,
} from "./MailingServices";
import { paypal, PaypalComponent } from "./Paypal";
import { photobooks, PhotobooksEditorDownloadComponent } from "./Photobooks";
import { productBuilder, ProductBuilderComponent } from "./productBuilder";
import {
  Placeholder,
  PlaceholderGroupMember,
  PlaceholderPlugin,
} from "../pluginsInfrastructure/PluginRegistryTypes";
import {
  AddToCartCta,
  AlbelliGalleryCta,
  AlbelliStudioCta,
  BulkOrderCta,
  CtasComponent,
  GalleryCta,
  NinetyNineDesignsCta,
  StudioBlankCta,
  StudioCta,
  StudioCustomCta,
  StudioFullBleedCta,
  StudioTemplateCta,
  UploadAndGoCta,
  UploadAndPrintCta,
  ctas,
  DesignAssistantCta,
  EditYourTemplateCta,
} from "./Ctas";
import { AccessoriesComponent, checksAccessories } from "./Accessories";
import { HeroGalleryComponent, heroGallery } from "./HeroGallery";
import { SocialCurationsComponent, socialCurations } from "./SocialCurations";
import { shippingCalculator, ShippingCalculatorComponent } from "./ShippingCalculator";
import {
  ProductConfiguratorComponent,
  productConfigurator,
} from "./productOptionProductConfigurator";
import {
  ProductConfiguratorTestComponent,
  ProductConfiguratorUnwindingComponent,
  productConfiguratorTest,
} from "./productOptionProductTestConfigurator";
import {
  ProductOptionQuantitySelectorsPercentSavingComponent,
  productOptionQuantitySelectors,
} from "./ProductOptionQuantitySelectors";

const plugins: PlaceholderPlugin[] = [
  heroGallery,
  mailingServices,
  photobooks,
  productBuilder,
  shippingCalculator,
  paypal,
  socialCurations,
  checksAccessories,
  ctas,
  productConfigurator,
  productConfiguratorTest,
  productOptionQuantitySelectors,
];

// For each placeholder, we accept a 2-dimension array.
// For each inner group, we render the first one, whose enable function is evaluated to true
// We render all components from evaluations of inner groups.
const pluginOrdering: { [key in Placeholder | PlaceholderGroupMember]?: string[][] } = {
  [Placeholder.Pricing]: [[PriceInfoComponent.name, ShippingCalculatorComponent.name]],
  [Placeholder.QuantityDropdown]: [
    [QuantitySelectorComponent.name, ProductOptionQuantitySelectorsPercentSavingComponent.name],
  ],
  [Placeholder.AfterCtas]: [[PhotobooksEditorDownloadComponent.name]],
  [Placeholder.ProductBuilderHeaderRight]: [],
  [Placeholder.AfterTab]: [
    [SocialCurationsComponent.name],
    [AccessoriesComponent.name],
    [PriceCalculatorComponent.name],
  ],
  [Placeholder.Top]: [],
  [Placeholder.Hero]: [[HeroGalleryComponent.name]],
  [Placeholder.ProductBuilder]: [[ProductBuilderComponent.name]],
  [Placeholder.ProductConfigurator]: [
    [
      ProductConfiguratorTestComponent.name,
      ProductConfiguratorUnwindingComponent.name,
      ProductConfiguratorComponent.name,
    ],
  ],
  [Placeholder.AfterPricing]: [[PaypalComponent.name]],
  [Placeholder.Ctas]: [[CtasComponent.name]],
  [PlaceholderGroupMember.CtaAddToCart]: [[AddToCartCta.name]],
  [PlaceholderGroupMember.CtaAlbelliGallery]: [[AlbelliGalleryCta.name]],
  [PlaceholderGroupMember.CtaAlbelliStudio]: [[AlbelliStudioCta.name]],
  [PlaceholderGroupMember.CtaBulkOrder]: [[BulkOrderCta.name]],
  [PlaceholderGroupMember.CtaGallery]: [[GalleryCta.name]],
  [PlaceholderGroupMember.CtaNinetyNineDesigns]: [[NinetyNineDesignsCta.name]],
  [PlaceholderGroupMember.CtaStudio]: [[StudioCta.name]],
  [PlaceholderGroupMember.CtaStudioBlank]: [[StudioBlankCta.name]],
  [PlaceholderGroupMember.CtaStudioCustom]: [[StudioCustomCta.name]],
  [PlaceholderGroupMember.CtaStudioFullBleed]: [[StudioFullBleedCta.name]],
  [PlaceholderGroupMember.CtaStudioTemplate]: [[StudioTemplateCta.name]],
  [PlaceholderGroupMember.CtaUploadAndGo]: [[UploadAndGoCta.name]],
  [PlaceholderGroupMember.CtaUploadAndPrint]: [[UploadAndPrintCta.name]],
  [PlaceholderGroupMember.CtaDesignAssistant]: [[DesignAssistantCta.name]],
  [PlaceholderGroupMember.CtaEditTemplate]: [[EditYourTemplateCta.name]],
};

export { plugins, pluginOrdering };
